// Function index:
//   renderHexHistory(host, worldId, hexId) — render hex event history narrative

import { getHexHistory } from '../api.js';

export async function renderHexHistory(
  host: HTMLElement,
  worldId: number,
  hexId: number,
): Promise<void> {
  host.innerHTML = '';
  const loading = document.createElement('div');
  loading.className = 'loading';
  loading.textContent = 'Loading history...';
  host.appendChild(loading);

  try {
    const result = await getHexHistory(worldId, hexId, 50);
    const { narrative, events } = result;

    const container = document.createElement('div');
    container.className = 'hex-history';

    const title = document.createElement('div');
    title.className = 'hex-history-title';
    title.textContent = 'Event History';
    container.appendChild(title);

    const narrativeDiv = document.createElement('div');
    narrativeDiv.className = 'hex-history-narrative';
    narrativeDiv.textContent = narrative;
    container.appendChild(narrativeDiv);

    const eventsDiv = document.createElement('div');
    eventsDiv.className = 'hex-history-events';

    for (const evt of events) {
      const eventEl = document.createElement('div');
      eventEl.className = 'history-event';

      const typeSpan = document.createElement('span');
      typeSpan.className = 'event-type';
      typeSpan.textContent = evt.type;
      eventEl.appendChild(typeSpan);

      const timeSpan = document.createElement('span');
      timeSpan.className = 'event-time';
      timeSpan.textContent = new Date(evt.created_at).toLocaleDateString();
      eventEl.appendChild(timeSpan);

      const summaryP = document.createElement('p');
      summaryP.textContent = evt.summary;
      eventEl.appendChild(summaryP);

      eventsDiv.appendChild(eventEl);
    }

    container.appendChild(eventsDiv);

    host.innerHTML = '';
    host.appendChild(container);
  } catch {
    host.innerHTML = '';
    const errorDiv = document.createElement('div');
    errorDiv.className = 'error';
    errorDiv.textContent = 'Could not load history';
    host.appendChild(errorDiv);
  }
}

